// Bake EXIF Orientation into pixels before upload — bucket strips EXIF without re-rotating, so phone-camera photos display rotated otherwise.
export const normalizePhotoOrientation = (file: File): Promise<File> => {
	return new Promise((resolve) => {
		if (!file.type.startsWith('image/') || file.type === 'image/gif') {
			resolve(file);
			return;
		}

		const url = URL.createObjectURL(file);
		const img = new Image();

		img.onload = () => {
			try {
				const canvas = document.createElement('canvas');
				canvas.width = img.naturalWidth;
				canvas.height = img.naturalHeight;
				const ctx = canvas.getContext('2d');
				if (!ctx) {
					URL.revokeObjectURL(url);
					resolve(file);
					return;
				}
				ctx.drawImage(img, 0, 0);
				canvas.toBlob(
					(blob) => {
						URL.revokeObjectURL(url);
						if (!blob) {
							resolve(file);
							return;
						}
						const baseName =
							file.name.replace(/\.[^.]+$/, '') || 'photo';
						resolve(
							new File([blob], `${baseName}.jpg`, {
								type: 'image/jpeg',
								lastModified: file.lastModified,
							}),
						);
					},
					'image/jpeg',
					0.92,
				);
			} catch (err) {
				URL.revokeObjectURL(url);
				console.warn(
					'[normalizePhotoOrientation] re-encode failed',
					err,
				);
				resolve(file);
			}
		};

		img.onerror = (err) => {
			URL.revokeObjectURL(url);
			console.warn(
				'[normalizePhotoOrientation] image decode failed',
				err,
			);
			resolve(file);
		};

		img.src = url;
	});
};
